module.exports = __webpack_public_path__ + "static/media/password_reset.b1cb3966.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/password_reset.svg
// module id = 475
// module chunks = 0